import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';
import type { SessionSummary } from 'src/services/api/getForecastSessions';

type RenameForecastSessionVariables = {
  sessionId: string;
  name: string;
};

async function renameForecastSessionRequest({
  sessionId,
  name,
}: RenameForecastSessionVariables) {
  const { data } = await api.patch<SessionSummary>(
    `/sales-forecasting-sessions/${sessionId}`,
    { name },
  );

  return data;
}

export function useRenameForecastSession(
  options?: Omit<
    UseMutationOptions<SessionSummary, Error, RenameForecastSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<SessionSummary, Error, RenameForecastSessionVariables> {
  return useMutation({
    mutationFn: renameForecastSessionRequest,
    ...options,
  });
}
